/**
 * Commitment API dates are ISO instants. The calendar grid and `date-fns format(..., 'yyyy-MM-dd')`
 * use the viewer's local calendar day, so bucketing must use local date parts or events land on
 * the wrong cell (e.g. NZ: 2026-04-30T17:00:00.000Z is still May 1 locally).
 */
export function commitmentDateToCalendarKey(isoOrDate: string | Date): string {
  const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Avoid sending start-of-month local as ISO (it becomes previous month in UTC for TZ ahead of UTC). */
export function calendarMonthToApiDate(month: Date): string {
  const y = month.getFullYear();
  const m = month.getMonth();
  return new Date(y, m, 15, 12, 0, 0, 0).toISOString();
}
